// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.camera-controls-app-width {
    width: 500px;
}

.camera-controls-app-input-field {
    width: 150px;
}

.custom-checkbox-style .ant-checkbox {
    padding: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/asset/style/manualmode/camera_controls_app.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":[".camera-controls-app-width {\n    width: 500px;\n}\n\n.camera-controls-app-input-field {\n    width: 150px;\n}\n\n.custom-checkbox-style .ant-checkbox {\n    padding: 0 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
